export const ar = {
  header: {
    title: "انطلق عالمياً. مقابل 2 دولار لكل فيديو قصير. أي لغة!",
    subtitle: "🔥ادفع مقابل النتيجة فقط – من $0.089 إلى $0.009 لكل ثانية🔥",
  },
  steps: {
    uploadVideo: "رفع الفيديو",
    selectLanguages: "اختيار اللغات",
    conversionResult: "التحويل والنتيجة",
  },
  upload: {
    dragAndDrop: "اسحب ملف الفيديو وأفلته هنا",
    orClickToSelect: "أو انقر للاختيار",
    supportedFormats: "الصيغ المدعومة: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• الحد الأقصى لحجم الملف: 200 MB",
    maxDuration: "• الحد الأقصى لمدة الفيديو: 30 ثانية",
    processingTime: "• المعالجة تستغرق من 2 إلى 15 دقيقة حسب دقة الفيديو",
    chooseFile: "اختر ملفًا",
    selectedFile: "الملف المختار:",
    size: "الحجم:",
    fileTypeError: "يرجى اختيار ملف فيديو",
    fileSizeError: "حجم الملف ({size} MB) يتجاوز الحد الأقصى البالغ 200 MB",
    durationError: "مدة الفيديو ({duration} ثانية) تتجاوز الحد الأقصى البالغ 30 ثانية",
    fileReadError: "تعذر قراءة ملف الفيديو. يرجى تجربة ملف آخر.",
  },
  languages: {
    sourceAudioLanguage: "لغة الصوت الأصلية",
    targetAudioLanguage: "لغة الصوت الهدف",
    selectLanguage: "اختر اللغة...",
  },
  languageOptions: {
    ru: "الروسية",
    en: "الإنجليزية",
    es: "الإسبانية",
    fr: "الفرنسية",
    de: "الألمانية",
    it: "الإيطالية",
    pt: "البرتغالية",
    pl: "البولندية",
    zh: "الصينية",
    ja: "اليابانية",
    ko: "الكورية",
    bg: "البلغارية",
    hr: "الكرواتية",
    cs: "التشيكية",
    da: "الدانماركية",
    nl: "الهولندية",
    et: "الإستونية",
    fi: "الفنلندية",
    el: "اليونانية",
    hu: "الهنغارية",
    ga: "الأيرلندية",
    lv: "اللاتفية",
    lt: "الليتوانية",
    mt: "المالطية",
    ro: "الرومانية",
    sk: "السلوفاكية",
    sl: "السلوفينية",
    sv: "السويدية",
  },
  conversion: {
    replaceAudio: "استنساخ صوتي",
    uploadVideoAndSelectLanguages: "ارفع فيديو واختر اللغات للمتابعة",
    fixValidationError: "يرجى إصلاح خطأ التحقق من الملف أعلاه",
    createSubtitles: "إنشاء ترجمات",
    uploadVideoForSubtitles: "ارفع فيديو لإنشاء الترجمات",
    selectTranslationLanguage: "اختر لغة الترجمة",
  },
  demo: {
    seeVeviInAction: "شاهد VEVI أثناء العمل",
    watchHowItWorks: "اكتشف كيف تعمل تقنية استبدال الصوت بالذكاء الاصطناعي",
    beforeEnglish: "قبل (الإنجليزية)",
    originalPresentation: "العرض الأصلي",
    afterSpanish: "بعد (الإسبانية، الفرنسية، الصينية، الإيطالية)",
    aiTranslatedVoice: "تمت الترجمة بالذكاء الاصطناعي بصوت طبيعي",
    demoTitle: "عرض توضيحي - VEVI",
  },
  reviews: {
    title: "ماذا يقول عملاؤنا",
    subtitle: "موثوق من محترفي التسويق حول العالم",
    customerReviews: [
      {
        name: "Sarah Johnson",
        position: "مديرة التسويق الرقمي",
        company: "TechFlow Solutions",
        text: "ساعدنا VEVI على توطين فيديوهاتنا بسرعة وجودة ممتازة.",
      },
      {
        name: "Michael Chen",
        position: "مدير تسويق المحتوى",
        company: "GlobalReach Media",
        text: "النتيجة طبيعية جدًا وسهلة الاستخدام لفِرَق متعددة المناطق.",
      },
      {
        name: "Emma Rodriguez",
        position: "أخصائية تسويق العلامة",
        company: "InnovateCorp",
        text: "خفضنا التكاليف بشكل كبير ووسعنا وصولنا لأسواق جديدة.",
      },
      {
        name: "David Thompson",
        position: "مدير حملات تسويقية",
        company: "NextGen Brands",
        text: "السرعة والجودة في VEVI ممتازتان لفرق التسويق العالمية.",
      },
      {
        name: "Lisa Park",
        position: "قائدة تسويق الشبكات الاجتماعية",
        company: "CreativeEdge Agency",
        text: "حل احترافي وبسيط لتقديم فيديوهات متعددة اللغات للعملاء.",
      },
      {
        name: "James Wilson",
        position: "مدير تسويق الأداء",
        company: "ScaleUp Ventures",
        text: "حققنا عائدًا قويًا مع تقليل التكاليف وتسريع التسليم.",
      },
    ],
  },
  payment: {
    title: "دفع التحويل",
    processingCost: "تكلفة المعالجة",
    duration: "المدة:",
    baseCost: "التكلفة الأساسية",
    discount: "الخصم ({promoCode}):",
    discountAmount: "قيمة الخصم:",
    total: "الإجمالي:",
    emailToReceiveResult: "البريد الإلكتروني لاستلام النتيجة",
    emailPlaceholder: "your-email@example.com",
    promoCode: "🎟️ كود الخصم (اختياري)",
    promoCodePlaceholder: "أدخل كود الخصم",
    check: "تحقق",
    checking: "جارٍ التحقق...",
    addSubtitles: "إضافة ترجمة نصية للفيديو",
    addSubtitlesDescription: "إنشاء ودمج الترجمة النصية في اللغة الهدف",
    highQualityTranslation: "• ترجمة عالية الجودة بالذكاء الاصطناعي",
    originalVideoPreserved: "• الحفاظ على الفيديو الأصلي",
    fastProcessing: "• معالجة سريعة (عادة 5-10 دقائق)",
    resultWillBeSent: "• سيتم إرسال النتيجة إلى البريد المحدد",
    cancel: "إلغاء",
    continue: "متابعة",
    enterEmail: "يرجى إدخال بريدك الإلكتروني",
    enterValidEmail: "يرجى إدخال بريد إلكتروني صحيح",
    enterPromoCode: "يرجى إدخال كود الخصم",
    invalidPromoCode: "كود خصم غير صالح",
    validPromoCode: "كود خصم صالح! تم تطبيق خصم {discount}%",
  },
  progress: {
    title: "جاري معالجة الفيديو",
    uploadingVideo: "📤 جارٍ رفع ملف الفيديو...",
    uploadingAndExtracting: "🎬 جارٍ الرفع واستخراج الصوت",
    transcribingAndTranslating: "🗣️ جارٍ نسخ الكلام وترجمته",
    synthesizingAudio: "🎵 جارٍ إنشاء المسار الصوتي الجديد",
    step: "الخطوة:",
    error: "خطأ",
  },
  result: {
    title: "اكتمل! تمت معالجة الفيديو",
    conversionCompleted: "تم التحويل بنجاح!",
    processedVideoDescription: "🎬 الفيديو بعد المعالجة مع استنساخ الصوت",
    payAndDownload: "ادفع وحمّل",
    videoNotAvailable: "الفيديو غير متاح",
    useDownloadButton: "يرجى استخدام زر التحميل أدناه",
    downloadError: "خطأ في التحميل",
  },
  emailSent: {
    title: "تم إرسال الفيديو! 🎉",
    videoOnWay: "الفيديو في طريقه إلى بريدك الإلكتروني 🙏❤️",
    checkInbox: "تحقق من البريد الوارد والرسائل غير المرغوب فيها.",
    whatsNext: "ما الخطوة التالية؟",
    checkEmail: "• تحقق من بريدك ({email})",
    checkSpam: "• افحص مجلد الرسائل غير المرغوب فيها إن لم تجده",
    downloadAndEnjoy: "• حمّل الفيديو واستمتع بالنسخة المدبلجة!",
    close: "إغلاق",
    processAnotherVideo: "معالجة فيديو آخر",
  },
  processingSteps: {
    uploading: "جارٍ رفع الفيديو...",
    extracting: "جارٍ استخراج الصوت...",
    transcribing: "جارٍ نسخ الكلام...",
    translating: "جارٍ ترجمة المحتوى...",
    synthesizing: "جارٍ إنشاء الصوت الجديد...",
    rendering: "جارٍ إخراج الفيديو النهائي...",
    complete: "اكتملت المعالجة!",
  },
  common: {
    minutes: "دقائق",
    seconds: "ثوانٍ",
    loading: "جارٍ التحميل...",
    error: "خطأ",
    success: "نجاح",
  },
  socialMedia: {
    title: "ابقَ على تواصل",
    description: "احصل على آخر تحديثات تقنيات الصوت بالذكاء الاصطناعي",
  },
  services: {
    dubbing: "الدبلجة",
    voiceClone: "دبلجة باستنساخ الصوت",
    newVoice: "دبلجة بصوت جديد",
    multilingual: "دبلجة متعددة اللغات",
    multiSpeaker: "دبلجة متعددة المتحدثين",
    subtitles: "ترجمات نصية",
    subtitlesOnly: "ترجمات نصية فقط",
    multilingualSubtitles: "ترجمات نصية متعددة اللغات",
    subtitlesDescription: "أنشئ ترجمات دقيقة لأي منصة تلقائيًا.",
    subtitlesPrice: "تكلفة المعالجة: 0.01$ / ثانية",
    addSubtitles: "إضافة ترجمة نصية",
    needsTranslation: "هل تحتاج ترجمة؟",
    translationLanguage: "لغة الترجمة",
  },
  footer: {
    legal: "قانوني",
    privacyPolicy: "سياسة الخصوصية",
    termsOfUse: "شروط الاستخدام",
  },
  nav: {
    blog: "المدونة",
  },
  blog: {
    title: "مدونة VEVI Monster",
    subtitle: "قصص وأفكار عن عالم VEVI",
    readMore: "اقرأ المزيد",
    backToBlog: "العودة إلى المدونة",
    articleNotFound: "المقال غير موجود",
    characteristics: "الخصائص",
    articles: {},
  },
  faq: {
    title: "الأسئلة الشائعة",
    subtitle: "كل ما تحتاج معرفته عن VEVI",
    questions: [
      { question: "هل تعملون على الصوت فقط؟", answer: "نعم، نستبدل الصوت مع الحفاظ على طبيعته." },
      { question: "هل أدفع قبل أم بعد؟", answer: "بعد المعاينة. تسمع النتيجة أولًا ثم تدفع." },
      { question: "هل يوجد استرداد؟", answer: "تدفع فقط إذا كنت راضيًا عن النتيجة." },
      { question: "فيديو أطول من 15 دقيقة؟", answer: "تواصل مع مساعدنا عبر الدردشة للحصول على التعليمات." },
      { question: "هل يمكن اختيار صوت آخر؟", answer: "نقوم فقط باستنساخ صوتك الحالي." },
      { question: "ما الحد الأدنى للدفع؟", answer: "يبدأ من 0.50$." },
      { question: "كيف أستلم الفيديو؟", answer: "تحميل مباشر + نسخة على البريد بعد الدفع." },
      { question: "هل توجد خصومات للطلبات الكبيرة؟", answer: "نعم، تواصل معنا عبر الدردشة." },
      { question: "لم تجد الإجابة؟", answer: "اسأل مساعدنا في الدردشة وسنساعدك فورًا." },
      { question: "صيغة غير مدعومة؟", answer: "استخدم محول صيغة أو تواصل معنا للدعم السريع." },
      {
        question: "فيديـوي يحتوي مصطلحات خاصة. هل يمكن ضبط النطق؟",
        answer: "نعم، أرسل لنا المصطلحات في الدردشة وسنوضح طريقة تثبيتها.",
      },
      {
        question: "لم يصلني البريد، ماذا أفعل؟",
        answer: "قد يتغير وقت المعالجة حسب الضغط. ملفك آمن وسيصلك الإشعار فور الجاهزية.",
      },
    ],
  },
};
